import {createAction} from '@reduxjs/toolkit';
import {notifyError} from '@src/components/notifier/notify.tsx';
import {selectFilteredResultsList} from '@src/selectors/results.js';
import workerErrors from '@src/worker/errors.js';

const PREFIX = 'results';

export const resetResults = createAction(`${PREFIX}/reset`);
export const resultsCompleted = createAction(`${PREFIX}/completed`);
export const updateStatus = createAction(`${PREFIX}/updateStatus`);

export const addResultToOrder = createAction(`${PREFIX}/addToOrder`);
export const addResultToView = createAction(`${PREFIX}/addToView`);

export const removeResultFromOrder = createAction(`${PREFIX}/removeFromOrder`);
export const removeAllFromOrder = createAction(`${PREFIX}/removeAllFromOrder`);
export const removeResultFromView = createAction(`${PREFIX}/removeFromView`);
export const removeAllFromView = createAction(`${PREFIX}/removeAllFromView`);

export const addItemsToOrder = createAction(`${PREFIX}/addItemsToOrder`);
export const addItemsToView = createAction(`${PREFIX}/addItemsToView`);

export const removeItemsFromOrder = createAction(
  `${PREFIX}/removeItemsFromOrder`,
);
export const removeItemsFromView = createAction(
  `${PREFIX}/removeItemsFromView`,
);

// support shift + click
export const selectResults = createAction(`${PREFIX}/selectMany`);

// Keep for Shift + Click support in OG UX
export const selectMulti = payload => (dispatch, getState) => {
  const state = getState();
  const {resultsById, viewResults} = state.results;
  const resultsList = selectFilteredResultsList(state);
  // right now viewResults & orderResults have the same info
  const selectedResultsTimestamps = viewResults.map(
    r => resultsById[r].properties.acquired,
  );
  const selectTimestamps = [
    ...selectedResultsTimestamps,
    payload.result.properties.acquired,
  ];
  selectTimestamps.sort();
  const firstTimestamp = selectTimestamps[0];
  const lastTimestamp = selectTimestamps[selectTimestamps.length - 1];

  const newResults = resultsList.filter(
    result =>
      result.properties.acquired >= firstTimestamp &&
      result.properties.acquired <= lastTimestamp &&
      !viewResults.includes(result.id),
  );
  dispatch(selectResults({resultIds: newResults.map(nr => nr.id)}));
};

export const handleResults = createAction(`${PREFIX}/handleWorkerResults`);

export const handleWorkerMessage = eventData => dispatch => {
  const {type, data} = eventData;

  if (data && !data.more) {
    dispatch(resultsCompleted());
  }

  if (type === 'add') {
    dispatch(updateStatus(data.loading));
    dispatch(handleResults(data.results));
  } else if (type === 'error') {
    if (data.code === workerErrors.INVALID_GEOMETRY) {
      notifyError({
        data: {
          title: 'Invalid search geometry',
          message:
            "The geometry used in your search doesn't appear to be valid. This could be due to a self-intersecting polygon.",
        },
      });
    } else if (data.code === workerErrors.INVALID_FIELD) {
      notifyError({
        data: {
          title: 'Error executing search',
          message:
            data.messages[0] || 'There was an error with the search filters.',
        },
      });
    } else {
      notifyError({
        data: {
          title: 'Unexpected API response',
          message:
            'The API returned an unexpected response.  This could be due to rate limiting.  Please try your request again.',
        },
      });
    }

    dispatch(updateStatus(false));
  }
};
